/* eslint-disable max-len */
/* eslint-disable max-lines */
import tw, { styled } from 'twin.macro';

export const MainfieldWrapper = styled.div`
  ${({ formFontSize, formFontType }) =>
    (formFontType || formFontSize) &&
    `
      font-family: ${formFontType}!important;
      font-size : ${formFontSize};
  `}
`;

export const FieldWrapper = styled.div`
  ${tw`my-4 relative`};
  ${({ formFontType, formFontSize }) =>
    (formFontSize || formFontType) &&
    `
  font-family: ${formFontType}!important;
  font-size : ${formFontSize};
`}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      display : flex;
      flex-direction: row;
      justify-content: space-between;
      align-items : flex-start;
      flex-wrap: wrap;
  `}
  @media (max-width: 576px) {
    display: block;
  }
`;

export const Field = styled.div`
  ${tw`m-0 clear-both`};
  :last-child {
    margin-bottom: 0;
  }
  ${(props) =>
    props.unstackableContainer &&
    `
    overflow-x: auto;
    overflow-y: visible;
  `}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
  display : flex;
  flex-direction: row;
  justify-content: space-between;
  align-items : flex-start;
  flex-wrap: wrap;
   `}
   @media (max-width: 576px) {
    display: block;
  }
`;

export const LabelWrapper = styled.label`
  ${tw`font-semibold text-base text-blackened block my-0 mt-0 mb-1 normal-case `};
  ${({ formBodyLabelColor, formLabelTransform, formFontSize, formTextColor, formFontType }) =>
    (formBodyLabelColor || formLabelTransform || formFontSize || formTextColor || formFontType) &&
    `
      color : ${formBodyLabelColor || formTextColor};
      text-transform: ${formLabelTransform};
      font-size : ${formFontSize};
      font-family: ${formFontType}!important;
  `}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex: 0 0 30%;
      margin-bottom: 0;
  `}
  &:after {
    ${(props) =>
      props.required &&
      `
      content : '*';
      margin: -.2em 0 0 .2em;
      color: #db2828;
    `}
  }
`;

export const TextAreaWrapper = styled.textarea`
  ${tw`w-full rounded m-0 py-3 px-4 bg-white outline-none border border-solid 
  border-greyed text-blackened text-base transition duration-100 ease-linear delay-0 overflow-auto opacity-70
  h-32 `}
  :focus {
    border-color: #85b7d9;
  }
  ${({ formFieldBorderColor, formFieldBackgroundColor, formFontType }) =>
    (formFieldBorderColor || formFieldBackgroundColor || formFontType) &&
    `
    border-color: ${formFieldBorderColor};
    background: ${formFieldBackgroundColor};
    font-family: ${formFontType}!important;
`};
  ${({ formFieldBorderRadius }) =>
    formFieldBorderRadius >= 0 &&
    `
border-radius : ${formFieldBorderRadius}px;
`}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
      @media (max-width: 576px) {
       width: 100%;
      }
`}
`;

export const ValidationWrapper = styled.div`
  ${tw`w-full relative inline-flex text-current font-normal text-base`};
`;

export const InputWrapper = styled.input`
  ${tw`w-full m-0 outline-none p-2.5 text-base bg-white border border-solid rounded opacity-70 border-greyed `};
  :focus {
    border-color: #85b7d9;
  }
  ${({ formFieldBorderColor, formFieldBackgroundColor, formFontType }) =>
    (formFieldBorderColor || formFieldBackgroundColor || formFontType) &&
    `
    border-color: ${formFieldBorderColor};
    background: ${formFieldBackgroundColor};
    font-family: ${formFontType}!important;
`};

  ${({ formFieldBorderRadius }) =>
    formFieldBorderRadius >= 0 &&
    `
border-radius : ${formFieldBorderRadius}px;
`}

  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
`}
  ${(props) =>
    props.type === 'radio' &&
    `
  width: auto !important;
  opacity: 0 !important;
  display: none;
 `}
 ${(props) =>
    props.left &&
    `
  border-top-left-radius: 0;
   border-bottom-left-radius: 0;
 `}
 ${(props) =>
    props.right &&
    `
 border-top-right-radius: 0;
 border-bottom-right-radius: 0;
 `}
 &.table-smiley {
    position: absolute;
  }
  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const SubtextWrapper = styled.p`
  ${tw`italic mt-1 text-base text-gray-500`}
  ${({ formBodyLabelColor, formFontSize, formTextColor, formFontType }) =>
    (formBodyLabelColor || formFontSize || formTextColor || formFontType) &&
    `
  color : ${formBodyLabelColor || formTextColor};
  font-size : ${formFontSize};
  font-family: ${formFontType}!important;
`}
${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
    margin-left : 30%;

    @media (max-width: 576px) {
      margin-left: 0 !important;
      padding-left:0;
   }
`}
${({ payment, labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    payment &&
    `
   margin-left: 0;
   margin-right: 30%;
`}
`;

export const DateInputWrapper = styled.div`
  ${tw`inline-flex w-full relative font-normal opacity-70`}

  > i.icon {
    opacity: 0.5;
    color: rgba(0, 0, 0, 0.87);
    position: absolute;
    pointer-events: none;
    left: 8px;
    top: 9px;
    right: auto;
  }
  > .flatpickr-input {
    padding-right: 35px !important;
    padding-left: 35px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    width: 100% !important;
    border: 1px solid rgba(34, 36, 38, 0.15) !important;
    border-radius: 4px !important;
    :focus {
      border-color: #85b7d9 !important;
    }
  }

  ${({ formFieldBorderColor, formFieldBackgroundColor, formFieldBorderRadius, formFontType }) =>
    (formFieldBorderColor || formFieldBackgroundColor || formFieldBorderRadius || formFontType) &&
    `
 > .flatpickr-input {
    border-color: ${formFieldBorderColor}!important;
    background: ${formFieldBackgroundColor}!important;
    border-radius : ${formFieldBorderRadius}px!important;
    font-family: ${formFontType}!important;
    opacity: 1!important;
  };

`};
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
      @media (max-width: 576px){
        width: 100%;
      }
`}
`;

export const FileUploadWrapper = styled.div`
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
flex : 0 0 70%;
`}
`;
export const LabelInputWrapper = styled.label`
  ${tw`inline-flex w-full relative font-normal opacity-70`}
  > input[type=number] {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .intl-tel-input {
    width: 100% !important;
    opacity: 1 !important;
  }

  > .intl-tel-input input[type='tel'] {
    width: 100% !important;
  }

  > .intl-tel-input input[type='tel'] {
    padding-top: 0.678571em;
    padding-bottom: 0.678571em;
    font-size: 1em;
    background: #fff;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 4px;
  }

  ${({ formFieldBorderColor, formFieldBackgroundColor, formFieldBorderRadius, formFontSize, formFontType }) =>
    (formFieldBorderColor || formFieldBackgroundColor || formFieldBorderRadius || formFontSize || formFontType) &&
    `

 > .intl-tel-input input[type="tel"] {
  border-color: ${formFieldBorderColor};
  background: ${formFieldBackgroundColor};
  border-radius : ${formFieldBorderRadius}px;
  font-size: ${formFontSize};
  font-family: ${formFontType}!important;
  opacity: 1 !mportant;
  }
`};
  ${({ formDirection }) =>
    formDirection === 'rtl' &&
    `
> .intl-tel-input input[type="tel"] {
    padding-right: 40px !important;
}
`}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
    @media (max-width: 576px){
        width: 100%;
    }
`}

${({ full }) =>
    full &&
    `
    > div[data-testid="rfs"] {
      width: 100%;
      font-size: 14px !important;
    }
`}
`;

export const LabelUnitWrapper = styled.div`
  ${tw`p-2 text-gray-500 px-4 rounded-r-sm font-bold bg-greyed`}
  ${({ formFieldBorderRadius, formFontSize, formFontType }) =>
    (formFieldBorderRadius || formFontSize || formFontType) &&
    `
  border-top-right-radius: ${formFieldBorderRadius}px;
  border-bottom-right-radius: ${formFieldBorderRadius}px;
  font-size : ${formFontSize};
  font-family: ${formFontType}!important;
  `}
`;

export const RatingsWrapper = styled.div`
  ${tw``};
  > i.icon.star.empty:before {
    content: '\\f005';
  }
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
    @media (max-width: 576px){
        width: 100%;
    }
`}
`;

export const RatingsIcon = styled.i`
  ${({ formBodyLabelColor, formTextColor, formFontSize, formFontType }) =>
    (formBodyLabelColor || formTextColor || formFontType) &&
    `
    color : ${formBodyLabelColor || formTextColor};
    font-size: ${formFontSize}
    font-family: ${formFontType}!important;
`}
`;

export const RowFieldWrapper = styled.div`
  ${tw`flex flex-wrap items-stretch -m-4 flex-col lg:flex-row `}
`;
export const DescriptionField = styled.div`
  ${({ formTextColor, formFontType }) =>
    (formTextColor || formFontType) &&
    `
    color: ${formTextColor}!important;
    font-family: ${formFontType}!important;
`}
`;

export const RowField = styled.div`
  ${tw`w-full lg:w-4/12 self-start flex-col align-top p-4 `}
`;

export const LabeledButton = styled.button`
  ${tw`bg-greyed p-2 text-gray-500 font-bold flex-initial flex-shrink-0 justify-between border-none`}
  ${({ right, formFieldBorderRadius }) =>
    right &&
    `
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-left: none;
` &&
    formFieldBorderRadius &&
    `
   border-bottom-right-radius: ${formFieldBorderRadius}px;
   border-top-right-radius: ${formFieldBorderRadius}px;;
`}


${({ left, formFieldBorderRadius }) =>
    left &&
    `
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: none;
` &&
    formFieldBorderRadius &&
    `
  border-bottom-left-radius: ${formFieldBorderRadius}px;
  border-top-left-radius: ${formFieldBorderRadius}px;
`}
 ${({ formFontType }) =>
    formFontType &&
    `
 font-family: ${formFontType}!important;
 `}
`;

export const MediaImageWrapper = styled.div`
  ${tw`w-full flex`}
  ${(props) =>
    props.placement === 'right' &&
    `
  justify-content : flex-end
`}
${(props) =>
    props.placement === 'center' &&
    `
  justify-content : center
`}
`;

export const MatrixRatingWrapper = styled.div`
  ${tw`overflow-x-auto overflow-y-visible`}
`;

export const RadioWrapper = styled.div`
  ${tw`py-1 m-1 relative`}
  ${({ inline }) =>
    inline &&
    `
    margin-right: 9em;
  `};
  @media (max-width: 768px) {
    margin-right: 16px;
  }
  ${({ formDirection }) =>
    formDirection === 'rtl' &&
    `
   margin-right: 0;
  `}
`;

export const MatrixRatingTable = styled.table`
  ${tw`border-solid border border-faintgray border-collapse w-full`}

  ${({ formBodyLabelColor, formFontType }) =>
    (formBodyLabelColor || formFontType) &&
    `
  color : ${formBodyLabelColor};
  font-family: ${formFontType}!important;
  
`}

${(props) =>
    props.noBorder &&
    `
  border: none;
`}
@media (max-width: 768px) {
    ${(props) =>
      !props.noBorder &&
      `
  border: 1px solid rgba(34,36,38,.15);
`}
  }
`;

export const TableHeaderWrapper = styled.tr`
  ${tw`border-b border-tableGrey`};
  border-bottom-style: solid;
  ${(props) =>
    props.stacked &&
    !props.unstacked &&
    `
  display: block;
`}
  ${(props) =>
    props.noBorder &&
    `
  border: none;
`}
@media (max-width: 768px) {
    ${(props) =>
      !props.unstacked &&
      `
  display:block;
  border-bottom: 1px solid rgba(0,0,0,.1);
  padding-top: 1em;
  padding-bottom: 1em;
  box-shadow: 0 -1px 0 0 rgba(0,0,0,.1) inset;
  `}
  }
`;
export const TableHead = styled.thead`
  ${(props) =>
    props.stacked &&
    !props.unstacked &&
    `
  display: none;
`}
  @media (max-width: 768px) {
    ${(props) =>
      !props.unstacked &&
      `
   display : none
  `}
  }
`;

export const MatrixHeader = styled.th`
  ${tw`border-b  border-l border-faintgray p-3 font-bold text-left cursor-auto`}
  border-bottom-color: rgba(34,36,38,.1);
  border-bottom-style: solid;
  border-left: 1px solid rgba(34, 36, 38, 0.1);
  ${(props) =>
    props.noBorder &&
    `
  border: none;
`}
  &:first-of-type {
    border-left: none;
  }
  ${({ formBodyLabelColor, formFontType }) =>
    (formBodyLabelColor || formFontType) &&
    `
    font-family: ${formFontType}!important;
    color : ${formBodyLabelColor}
`}
`;

export const MatrixBody = styled.td`
  ${tw`border-l border-t border-faintgray p-3`}
  border-left-color: rgba(34,36,38,.15);
  border-left-style: solid;
  color: inherit;
  ${(props) =>
    props.stacked &&
    !props.unstacked &&
    `
  display: block;
`}
  ${(props) =>
    props.noBorder &&
    `
  border: none;
`}
 &:before {
    ${(props) =>
      props.stacked &&
      !props.unstacked &&
      `
  content : attr(data-question);
  width: 30vw;
  display: inline-block;
  font-weight: bold;
  `};

    @media (max-width: 768px) {
      ${(props) =>
        !props.unstacked &&
        `
  content : attr(data-question);
  width: 30vw;
  display: inline-block;
  font-weight: bold;
  `}
      ${({ formBodyLabelColor, formFontType }) =>
        (formBodyLabelColor || formFontType) &&
        `
    color: ${formBodyLabelColor}
    font-family: ${formFontType}!important;
  `}
    }
  }
  > i.icon.star.empty:before {
    content: '\\f005';
  }
  @media (max-width: 768px) {
    ${(props) =>
      !props.unstacked &&
      `
   display : block;
   border: none;
  `}
  }
`;

export const SmileyLabel = styled.label`
  ${tw`inline-block`}
`;

export const RadioLabel = styled.label`
  ${tw`text-base text-black font-medium relative pl-8`};

  ${({ formDirection }) =>
    formDirection === 'rtl' &&
    `
  margin-left: 8em;
  padding-right: 2rem;
 `}
  &:before {
    content: '';
    position: absolute;
    transform: none;
    width: 15px;
    height: 15px;
    border-radius: 500rem;
    top: 1px;
    left: 0;
    border: 1px solid #d4d4d5;
    background: rgb(255, 255, 254);
    ${(props) =>
      props.error &&
      `
    background: #fff6f6;
    border-color: #e0b4b4;
  `}
    ${({ formDirection }) =>
      formDirection === 'rtl' &&
      `
   right: 0;
 `}
  }
  ${({ formBodyLabelColor, formFontSize, formTextColor, formFontType, formLabelTransform }) =>
    (formBodyLabelColor || formFontSize || formTextColor || formFontType || formLabelTransform) &&
    `
   color : ${formBodyLabelColor || formTextColor};
   font-size:  ${formFontSize};
   text-transform: ${formLabelTransform};
   font-family: ${formFontType}!important;
`}
`;

export const MainChoiceWrapper = styled.div`
  ${tw`block mb-3 w-full`}
  ${(props) =>
    props.inline &&
    `
  display : inline-flex;
  flex-wrap: wrap;
`}
${({
    formFieldBorderColor,
    formFieldBackgroundColor,
    formFieldBorderRadius,
    formFieldColor,
    formFontSize,
    formDirection,
    formFontType,
  }) =>
    (formFieldBorderColor ||
      formFieldBackgroundColor ||
      formFieldColor ||
      formFontSize ||
      formFontType ||
      formFieldBorderRadius >= 0) &&
    `

 > .ui.dropdown, > .ui.fluid.dropdown  {
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-color: ${formFieldBorderColor};
  background: ${formFieldBackgroundColor};
  color : ${formFieldColor};
  font-size: ${formFontSize};
  opacity:0.7;
  padding: 0.625rem;
  border-radius : ${formFieldBorderRadius}px;
  font-family: ${formFontType}!important;
  ${
    formDirection === 'rtl' &&
    `
  text-align: right;
`
  };
> .label{
  color : ${formFieldColor};
};
  > .menu{
     width: 100% !important;
     > .item{
      color : ${formFieldColor};
       ${
         formDirection === 'rtl' &&
         `
          text-align: right;
       `
       }
     }
  }
  :focus {
    border-color: #85b7d9;
  }
}

`}

${({ formFieldBorderRadius }) =>
    formFieldBorderRadius >= 0 &&
    `
> .ui.dropdown, > .ui.fluid.dropdown  {
  border-radius : ${formFieldBorderRadius}px;
   }
`};
  > .ui.dropdown:not(.button) > .default.text,
  > .ui.default.dropdown:not(.button) > .text {
    color: inherit !important;
    font-size: inherit !important;
  }

  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
  flex : 0 0 70%;
  @media (max-width: 576px){
  width: 100%;
}
`}
`;

export const OptionWrappper = styled.div`
  ${tw`mb-2.5`}

  ${(props) =>
    props.size === 'sm' &&
    `
  width: 150px;
  margin-right: 8rem;
`}
${(props) =>
    props.size === 'md' &&
    `
  width: 200px;
  margin-right: 6.5rem
`}
${(props) =>
    props.size === 'lg' &&
    `
  width: 330px;
  margin-right: 4rem;
`}
${({ formDirection, size }) =>
    formDirection === 'rtl' &&
    size === 'sm' &&
    `
margin-right:0;
margin-left: 8rem;
`}
${({ formDirection, size }) =>
    formDirection === 'rtl' &&
    size === 'md' &&
    `
margin-right:0;
 margin-left: 6.5rem;
`}
${({ formDirection, size }) =>
    formDirection === 'rtl' &&
    size === 'lg' &&
    `
margin-right:0;
margin-left: 4rem;
`}
`;

export const OptionLabel = styled.label`
  ${tw`text-base font-mediumbold mt-1`};
  ${({ formBodyLabelColor, formFontSize, formTextColor, formFontType }) =>
    (formBodyLabelColor || formFontSize || formTextColor || formFontType) &&
    `
   color : ${formBodyLabelColor || formTextColor};
   font-size:  ${formFontSize};
   font-family: ${formFontType}!important;
`}
`;

export const RadioImageWrapper = styled.label`
  ${tw`block relative`}
`;

export const ImageRadio = styled.input`
  ${tw`hidden`}
`;

export const ImageWrapper = styled.img`
  ${tw`max-w-full m-1`}
  ${(props) =>
    props.alt === 'Paypal' &&
    `
  width: 400px;
`}
${(props) =>
    props.placement === 'right' &&
    `
  align-self: flex-end
`}
${(props) =>
    props.placement === 'center' &&
    `
  align-self : center;
`}
`;

export const PayPalImageWrapper = styled.div`
  ${tw``}
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 30%;
      @media (max-width: 576px) {
        width: 100%;
     }
`}
`;

export const CheckboxFieldsWrapper = styled.div`
  ${tw`flex flex-row`}
  ${(props) =>
    props.inline
      ? `
        margin: 0 0 1rem;
        align-items: center;
      & > :first-of-type {
        margin-right: 0.857rem;
      }`
      : `  
      display: block;
      margin: 0 0 1rem;  
    `}
${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
      @media (max-width: 576px) {
        width: 100%;
     }
`}
`;
export const CheckboxField = styled.div`
  ${tw`py-0 pl-0 flex-initial pr-4 my-2 mb-4`}
  :first-of-type {
    border-left: none;
    box-shadow: none;
  }
  & .inline :first-of-type {
    margin-right: 0.857rem;
  }
  > only-child {
    margin: 0;
  }
`;

export const Checkbox = styled.div`
  ${tw`inline-block relative outline-none align-baseline min-h-5 text-base min-w-60`}
`;

export const CheckboxInput = styled.input`
  ${tw`cursor-pointer absolute top-0 left-0 w-5 h-5 opacity-0 `}
`;

export const CheckboxInputLabel = styled.label`
  ${tw`ml-2 block pl-7 outline-none text-base`}
  ${({ formBodyLabelColor, formFontSize, formTextColor, formFontType, formLabelTransform }) =>
    (formBodyLabelColor || formFontSize || formTextColor || formFontType || formLabelTransform) &&
    `
  color : ${formBodyLabelColor || formTextColor};
  font-size: ${formFontSize};
  text-transform: ${formLabelTransform};
  font-family: ${formFontType}!important;
`}
::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 17px;
    height: 17px;
    content: '';
    border: 1px solid #d4d4d5;
    border-radius: 0.2rem;
    background: rgb(255, 255, 254);
    ${({ formDirection }) =>
      formDirection === 'rtl' &&
      `
   right: -22px;
 `}
  }
`;

export const FileUploadButton = styled.button`
  ${tw`cursor-pointer inline-block min-h-4 outline-none align-baseline 
text-center no-underline px-6 py-3 bg-transparent text-lightGray font-normal 
normal-case rounded leading-4 border border-solid border-grayish-200
`};
  box-shadow: 0 0 0 1px rgba (34, 36, 38, 0.15) inset;
  :active {
    background: #f8f8f8;
    color: rgba(0, 0, 0, 0.9);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
  }
  :focus,
  :hover {
    background: #fff;
    color: rgba(0, 0, 0, 0.9);
    outline: none;
    box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.35) inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
  }
`;

export const RemoveFile = styled.p`
  ${tw`cursor-pointer flex text-center mb-0 ml-4 text-red-600`}
`;

export const ScaleWrapper = styled.div`
  ${tw`flex -mx-2`}
  ${(props) =>
    props.inline
      ? `
  align-items: center
  margin: 0 0 1em;
`
      : `
  display: block;
  margin: .5em 0;
  padding: 0;
`}

& > label {
    margin: 0 0 0.28571429rem 0;
  }
  & .radio.checkbox {
    min-height: 15px;
  }
  input[type='radio'] {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0 !important;
    outline: 0;
    z-index: 3;
    width: 17px;
    height: 17px;
  }
  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
  flex : 0 0 70%;
  @media (max-width: 576px){
  width: 100%;
}
`}
`;

export const ScaleField = styled.div`
${tw`m-0 p-0 pr-4`}
}
`;

export const ScaleRadioUnit = styled.label`
  ${tw`cursor-auto relative block outline-none font-normal pl-7 ml-2`}
  :: before {
    content: '';
    transform: none;
    width: 15px;
    height: 15px;
    border-radius: 500rem;
    top: 1px;
    left: 0;
    position: absolute;
    background: #fff;
    transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease,
      -webkit-transform 0.1s ease, -webkit-box-shadow 0.1s ease;
    border: 1px solid #d4d4d5;
  }
  :: after {
    top: 1px;
    left: 0;
    width: 15px;
    height: 15px;
    opacity: 0;
    font-size: 12px;
    transform: scale(0.46666667);
    background-color: rgba(0, 0, 0, 0.87);
  }
  :hover {
    color: rgba(0, 0, 0, 0.8);
  }
`;

export const SignatureWrapper = styled.div`
  & > canvas {
    border-bottom: 1px dotted black;
    margin-bottom: 5px;
    width: 100% !important;
    background: white;
  }

  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
  flex : 0 0 70%;
  @media (max-width: 576px){
  width: 100%;
}
`}
`;

export const SignatureButton = styled.button`
  ${tw`font-medium mr-2 bg-transparent rounded cursor-pointer inline-block min-h-4 outline-none align-baseline 
text-center no-underline px-6 py-3 leading-4 border border-solid`}
  ${({ formFontType }) =>
    formFontType &&
    `
font-family: ${formFontType}!important;
`}
  &.negative {
    box-shadow: 0 0 0 1px #db2828 inset;
    color: #db2828;
    :active {
      box-shadow: 0 0 0 1px #b21e1e inset;
      color: #b21e1e;
    }
    :focus,
    :hover {
      background: 0 0;
      -webkit-box-shadow: 0 0 0 1px #ca1010 inset;
      box-shadow: 0 0 0 1px #ca1010 inset;
      color: #d01919;
    }
  }
  &.positive {
    box-shadow: 0 0 0 1px #21ba45 inset;
    color: #21ba45;
    :active {
      box-shadow: 0 0 0 1px #198f35 inset;
      color: #198f35;
      outline: none;
    }
    :focus,
    :hover {
      background: 0 0;
      -webkit-box-shadow: 0 0 0 1px #0ea432 inset;
      box-shadow: 0 0 0 1px #0ea432 inset;
      color: #16ab39;
    }
  }
`;

export const Embed = styled.div`
  ${tw`w-full relative h-0 `}
  padding-bottom: 51%;
  & > iframe {
    border: 0;
    left: 0;
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
  }
`;

export const Header = styled.h4`
  ${tw`p-0 font-bold leading-5 -mb-8 p-0 text-2xl`}
  ${(props) =>
    props.divider &&
    `
  padding-bottom: .21428571rem;
  border-bottom: 1px solid rgba(34,36,38,.15);
`}
${({ formBodyLabelColor, formTextColor, formFontType }) =>
    (formBodyLabelColor || formTextColor || formFontType) &&
    `
    color : ${formBodyLabelColor || formTextColor};
    font-family: ${formFontType}!important;

`}
`;

export const TableFieldWrapper = styled.div`
  ${tw``}
  &.unstackable-container {
    overflow-x: auto;
    overflow-y: visible;
  }
`;

export const Table = styled.table`
${tw`w-full my-4 mx-0 rounded text-left text-blackened border-separate text-base `}
border: 1px solid rgba(34,36,38,.15);

${(props) =>
  props.noBorder &&
  `
  border: none;
  @media (min-width: 768px) {
    margin-left: -11px;
  }`}

${(props) =>
  props.unstackable &&
  `
  tr, th, td {
    border: none;
  }`}
&:first-of-type {
  margin-top: 0;
}

}

`;

export const TableHeader = styled.thead`
  ${(props) =>
    props.stacked &&
    props.unstackable &&
    `
    display: none;
    
  `}

  ${(props) =>
    props.stackTable &&
    `
  @media (max-width: 767px) {
    display: none;
    tr, th {
      width: auto;
      display: block;
    }
    
  }
  `}

  & th {
    cursor: auto;
    background: 0 0;
    padding: 0.92857143em 0.78571429em;
    vertical-align: inherit;
    font-weight: 700;
    text-transform: none;
    border-bottom: 1px solid rgba(34, 36, 38, 0.1);
    transition: background 0.1s ease, color 0.1s ease;
    :first-of-type {
      border-left: none;
    }
  }

  ${(props) =>
    props.noBorder &&
    `
    tr, th {
      border: none;
    }
  `}
`;

export const TableBody = styled.tbody`
  ${''}
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  td {
    padding: 0.78571429em 0.78571429em;
    background: 0 0;
  }
  ${(props) =>
    props.noBorder &&
    `
  & tr, td {
    border: none;
  }
  `}
  ${(props) =>
    props.stacked &&
    `
  tr, td {
    width: auto;
    display: block;
  }
  `}
  ${({ formTextColor }) =>
    formTextColor &&
    `
  td:before {
     color: ${formTextColor}
  }
  `}
  ${(props) =>
    props.stackTable &&
    `
  @media (max-width: 767px) {
    tr, td {
      width: auto;
      display: block;
    }
    & tr {
      padding-top: 1em;
      padding-bottom: 1em;
      box-shadow: 0 -1px 0 0 rgba(0,0,0,.1) inset;
    }
  }
  `}
  ${(props) =>
    props.dynamicTable &&
    `
    td {
      min-width: 250px;
      width: auto;
    }
  `}
`;

export const TableHeaderSpan = styled.span`
  ${(props) =>
    props.requiredStar &&
    `
    ::after {
      display: inline-block;
      vertical-align: top;
      content: '*';
      color: #db2828;
      margin: -.2em 0 0 .2em;
    }
    `}
  ${({ formBodyLabelColor, formLabelTransform, formFontSize, formTextColor, formFontType }) =>
    (formBodyLabelColor || formLabelTransform || formFontSize || formTextColor || formFontType) &&
    `
    color : ${formBodyLabelColor || formTextColor};
    text-transform: ${formLabelTransform};
    font-size : ${formFontSize};
    font-family: ${formFontType}!important;
`}
`;

export const FieldRenderer = styled.div`
  ${(props) =>
    props.Noclick &&
    `
    pointer-events: none;
    cursor: pointer;
 `}
`;

export const AddRowButton = styled(FileUploadButton)`
  box-shadow: 0 0 0 1px #198f35 inset !important;
  color: #198f35;
  background: 0 0 !important;
`;

export default {
  MainfieldWrapper,
  FieldWrapper,
  Field,
  LabelWrapper,
  TextAreaWrapper,
  ValidationWrapper,
  InputWrapper,
  SubtextWrapper,
  DateInputWrapper,
  LabelInputWrapper,
  LabelUnitWrapper,
  RatingsWrapper,
  LabeledButton,
  RadioWrapper,
  MainChoiceWrapper,
  RadioLabel,
  OptionWrappper,
  OptionLabel,
  RadioImageWrapper,
  ImageRadio,
  ImageWrapper,
  PayPalImageWrapper,
  CheckboxFieldsWrapper,
  CheckboxField,
  Checkbox,
  CheckboxInput,
  CheckboxInputLabel,
  FileUploadButton,
  RemoveFile,
  ScaleWrapper,
  ScaleField,
  ScaleRadioUnit,
  TableHeaderWrapper,
  DescriptionField,
  SignatureWrapper,
  SignatureButton,
  Embed,
  Header,
  Table,
  TableFieldWrapper,
  TableHeader,
  TableBody,
  TableHeaderSpan,
  FieldRenderer,
  AddRowButton,
  FileUploadWrapper,
  RatingsIcon,
};
